import { useState } from 'react'
import { DropdownProps } from '../types'

export const useDropdown = (
  args: Pick<DropdownProps, 'isOpen' | 'onOpenChange' | 'defaultIsOpen'>
) => {
  const [isOpen, setIsOpen] = useState<boolean>(Boolean(args.isOpen || args.defaultIsOpen))
  const isControlled = isOpen !== undefined

  const onOpenChange = (value: boolean) => {
    if (args.onOpenChange) {
      args.onOpenChange(value)
    } else {
      setIsOpen(value)
    }
  }

  return {
    isOpen: isControlled ? args.isOpen : isOpen,
    onOpenChange
  }
}
